<template>
    <v-dialog
      v-model="dialog"
      width="500"
      scrollable>
      <template v-slot:activator="{ on }">
        <v-btn large :block="block" :color="color" dark v-on="on">Een Expert Inschakelen?</v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline dark white--text justify-space-between pr-0"
          primary-title
        >
          De Slaapexpert
          <v-btn color="white" text @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-5">
          <p><strong>Wat goed dat u een expert wilt inschakelen!</strong> Al onze experts zijn ervaren psychologen verbonden aan een erkend Nederlands slaap centrum.</p>
          <v-alert type="warning">
            <strong>Let Op!</strong> Aan het inschakelen van een expert zijn kosten verbonden. Het opstellen van een professioneel rapport met 1 begeleidende online sessie kost € 99,-. Informeer eventueel bij uw zorgverzekeraar of deze kosten worden vergoed.
          </v-alert>
          <v-divider></v-divider>
          <v-form
          ref="form">
            <v-text-field
              v-model.trim="form.name"
              :rules="nameRules"
              label="Naam"
              name="name"
              type="text"
              required
            ></v-text-field>
            <v-text-field
              v-model.trim="form.email"
              :rules="emailRules"
              label="Email"
              name="email"
              type="email"
              required
            ></v-text-field>
            <v-text-field
              v-model="form.phone"
              :rules="phoneRules"
              label="Telefoonnummer"
              name="phone"
              type="tel"
              required
            ></v-text-field>
            <v-checkbox 
            v-model="form.agreement" 
            :rules="agreementRules"
            label="Hiermee gaat u akkoord met onze algemene voorwaarden.">
            </v-checkbox>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary"
            text
            @click="validate">
            Ja, ik wil hulp van een expert
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
const mobile = /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7}|((\\+31|0|0031)6)[-]{1}[1-9]{1}[0-9]{7})$/;
const landline = /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/;
const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  export default {
    name: 'expert',
    props: {
      color: {
        default: "dark"
      },
      block: {
        default: false
      }
    },
    data () {
      return {
        valid: true,
        dialog: false,
        form: {
          name: null,
          email: (this.$store.getters.user != null) ? this.$store.getters.user.email : null,
          phone: (this.$store.getters.user != null) ? this.$store.getters.user.phoneNumber : null,
          agreement: false
        },
        nameRules: [
          v => !!v || 'Uw naam is verplicht.',
          //v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
        emailRules: [
          v => !!v || 'Uw Email is verplicht.',
          v => email.test(v) || "Ongeldig email adres."
          //v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
        phoneRules: [
          v => !!v || 'Uw telefoonnummer is verplicht.',
          v => mobile.test(v) || landline.test(v) || 'Ongeldig nummer'
          //v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
        agreementRules: [
          v => !!v || 'U dient akkoord te gaan met de voorwaarden.',
          //v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.$http.post('api/Expert', this.form).then((res) => {
            this.dialog = false;
          });
        }
      }
    }
  }
</script>